export interface RuntimeConfig {
  APP_ENV: string
  TC_COOKIE_DOMAIN: string
  USER_EVENT_COLLECTOR_URL: string
  BRAZE_WEB_API_KEY: string
  BRAZE_WEB_SDK_ENABLED: string
  GOOGLE_RECAPTCHA_SITE_KEY: string
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__: RuntimeConfig
  }
}

/**
 * Drop-in replacement for `getConfig().publicRuntimeConfig`, deprecated ahead of removal
 * in Next.js 16.
 * Server-side: reads live `process.env` via `getServerRuntimeConfig()`.
 * Client-side: reads `window.__RUNTIME_CONFIG__`, set by `_document.page.tsx`'s
 * `getInitialProps` on each SSR response — the same mechanism Next.js used
 * internally to inject `publicRuntimeConfig` into `__NEXT_DATA__` for hydration.
 */
export function getRuntimeConfig(): RuntimeConfig {
  if (typeof window === "undefined") {
    // Dynamic require keeps this out of the client bundle (webpack dead-code-eliminates this branch)
    const { getServerRuntimeConfig } = require("./runtimeConfig.server")
    return getServerRuntimeConfig()
  }
  return window.__RUNTIME_CONFIG__
}
